import React from 'react';

const AccountsIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9.5 6a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zM19 24h-2v-2.13a4.34 4.34 0 0 0-4.34-4.34H6.34A4.34 4.34 0 0 0 2 21.87V24H0v-2.13a6.34 6.34 0 0 1 6.34-6.34h6.32A6.34 6.34 0 0 1 19 21.87z"/><path d="M14.5 4a5 5 0 0 0-1.39.22A6 6 0 0 1 14.7 6a3 3 0 0 1 0 6 6 6 0 0 1-1.59 1.8A5 5 0 1 0 14.5 4zM17.66 15.53h-1a7.85 7.85 0 0 1 2 2.15A4.32 4.32 0 0 1 22 21.87V24h2v-2.13a6.34 6.34 0 0 0-6.34-6.34z"/></svg>
    )
};

export default AccountsIcon;